export const ROLES = {
  ROLE_USER: "ROLE_USER",
  ROLE_MASTER: "ROLE_MASTER",
  ROLE_ADMIN: "ROLE_ADMIN",
  ROLE_USER_FIN: "ROLE_USER_FIN",
  ROLE_USER_GER: "ROLE_USER_GER",
  ROLE_USER_CRO: "ROLE_USER_CRO",
  ROLE_USER_ORG: "ROLE_USER_ORG",
  ROLE_ATLETA: "ROLE_ATLETA",
  ROLE_ORGANIZADOR: "ROLE_ORGANIZADOR",
} as const;

export const PERMISSIONS = {
  PERMISSION_VIEW: "PERMISSION_VIEW",
  PERMISSION_CREATE: "PERMISSION_CREATE",
  PERMISSION_DELETE: "PERMISSION_DELETE",
  PERMISSION_UPDATE: "PERMISSION_UPDATE",
  PERMISSION_FINANCEIRO: "PERMISSION_FINANCEIRO",
  PERMISSION_DASHBOARD: "PERMISSION_DASHBOARD",
} as const;

export type Permission = (typeof PERMISSIONS)[keyof typeof PERMISSIONS];
export type Role = (typeof ROLES)[keyof typeof ROLES];

export type AccessSnapshot = {
  roles: string[];
  permissions: string[];
  isSuperAdmin?: boolean;
  canAccessPanel?: boolean;
};

export type AccessRequirement = {
  roles?: readonly string[];
  permissions?: readonly string[];
};

export function checkAccess(
  access: AccessSnapshot,
  requirement: AccessRequirement | null | undefined
): boolean {
  if (!requirement) return true;
  if (access.isSuperAdmin) return true;

  const rolesOk = requirement.roles?.length
    ? access.roles.some((role) => requirement.roles!.includes(role))
    : true;

  const permissionsOk = requirement.permissions?.length
    ? access.permissions.some((perm) =>
        requirement.permissions!.includes(perm)
      )
    : true;

  return rolesOk && permissionsOk;
}

export function accessFromUser(
  user: AccessSnapshot | null | undefined
): AccessSnapshot {
  return {
    roles: user?.roles ?? [],
    permissions: user?.permissions ?? [],
    isSuperAdmin: user?.isSuperAdmin ?? false,
    canAccessPanel: user?.canAccessPanel ?? false,
  };
}
